export const environment = {
  name: 'dev',
  production: false,
  storageSecretKey: 'kcsOOYqpHio5Z8UdjVbWmoK0uoP59s8Y',
  baseURLHubAPI: 'https://hub-dev.drpservices.com/api',
  logBackendInterval: 5 // Time to send logs to the backend in minutes
};

export const aws = {
  aws_project_region: 'ca-central-1',
  aws_cognito_region: 'ca-central-1',
  aws_user_pools_id: 'ca-central-1_KLevzTpEQ',
  aws_user_pools_web_client_id: '59v09amrkmo2bhi9tcht5bn5nr',
  oauth: {
      domain: 'drp-dev.auth.ca-central-1.amazoncognito.com',
      scope: [
          'phone',
          'email',
          'openid',
          'profile',
          'aws.cognito.signin.user.admin'
      ],
      redirectSignIn: 'https://hub-dev.drpservices.com/callback',
      redirectSignOut: 'https://hub-dev.drpservices.com',
      responseType: 'code'
  }
};